var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Ipsative',{attrs:{"options":_vm.responseitems,"fields":_vm.fields,"value":_vm.ipsValue},on:{"input":function($event){return _vm.ipsInput($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }